import axios from './axios';

export default {
  signIn(payload) {
    return axios.post('students/sign_in', { student: payload });
  },
  signUp(payload) {
    return axios.post('students', { student: payload });
  },
  signOut() {
    return axios.delete('students/sign_out');
  },
  resetPassword(email) {
    return axios.post('students/password', { student: { email } });
  },
  changePassword(password, token) {
    return axios.put('students/password', { student: { password, reset_password_token: token } });
  },
  confirm({ token }) {
    return axios.get(`students/confirmation?confirmation_token=${token}`);
  },
  validateTicket(ticket) {
    return axios.post('student/validate_ticket', { ticket });
  },
};
